<template>
  <div v-loading="loading" :element-loading-text="loadingText" class="welcome-container">
    <div class="welcome-head">
      <div class="head-container">
        <img src="../../../static/logo2.png"/>
        <div class="segmentation">|</div>
        <div class="tag">分销货源市场</div>
      </div>
    </div>
    <div class="welcome-body">
      <div class="body-container">
        <div class="body-left">
          <div class="tag1">分销供应 一步到位</div>
          <div class="tag2">自营/1688选品分销</div>
          <div class="tag3">
            <div class="tag3-left">
              <ul>
                <li>一键授权号</li>
                <li>提交入驻</li>
              </ul>

            </div>
            <div class="tag3-right">
              <ul>
                <li>联 系 人：林先生</li>
                <li>招商热线：<span>172 6848 4904</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="body-right">
          <div v-if="isCkeck" class="welcome">

            <div class="login-bing-shop" v-if="isLogin">

              <div class="shop-list">
                <div class="title">选择要绑定的店铺</div>
                <div class="title2">您已经登陆账号：<span>{{ userData.account }}</span></div>
                <div class="shop-list-items">
                  <div v-if="shopList.length==0">请注册店铺并绑定！</div>
                  <div class="shop-list-item"
                       v-for="(item,index) in shopList"
                       :class="{'sel-shop-active':item.shop_id==selShopId}"
                       @click.stop="tochangeShop(item.shop_id)"
                       v-if="item.is_show==1&&item.status==1">
                    <div>
                      <el-avatar :src="item.logo"></el-avatar>
                    </div>
                    <div class="shop-name" :title="item.name">{{ item.name }}</div>
                  </div>
                </div>
              </div>
              <div class="but-group">
                <div class="but bind-but" v-if="shopList.length>0" @click="bindALibabaAccount()">确认绑定</div>
                <div class="but bind-add-store" size="mini" type="primary" @click="addNewStore()">注册店铺</div>
                <div class="but bind-exit" size="mini" type="primary" @click="exit">更换账号</div>
              </div>
            </div>
            <login v-else @loginOk="isUserLogin"></login>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="店铺类型" :visible.sync="visible" :close-on-click-modal="false" width="700px"
               @close="visible = false">
      <div style="display: flex; align-items: center; justify-content: space-between">
        <div v-for="(item, index) in cateList" :key="index" @click="goaddStore(item.shop_cate_id)" class="s_once">
          <el-image class="logo" :src="item.logimgo || require('../../../static/logo.png')" fit="cover"></el-image>
          <p>{{ item.title }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import router, {resetRouter} from "../../router";
import Login from "./login.vue";
import addStore from "../addStore/index.vue";

export default {
  computed: {
    addStore() {
      return addStore
    }
  },
  components: {Login},
  data() {
    return {
      loadingText: "加载中",
      loading: false,
      userData: null,
      cateList: [],
      isLogin: false,
      isCkeck: false,
      visible: false,
      showShopList: false,
      selShopId: null,
      shopList: [],
      code: "",
      key: ""
    }
  },
  created() {
    //这边是 阿里过来的
    if (this.$route.query.code) {
      this.code = this.$route.query.code
      this.getToken();

    } else if (this.$route.query.register_type == "alibaba" && this.$route.query.register_key) {
      //这边是注册新店铺过来的
      this.key = this.$route.query.register_key;
      // this.selShopId=this.$route.query.new_shop_id;
      this.isUserLogin()
    }
  },
  methods: {
    addNewStore() {
      this.$get(this.$api.shopCateList).then((res) => {
        if (res.status == 200) {
          this.cateList = res.data.list;
          this.visible = true;
        }
      });
    },
    goaddStore(type) {
      this.$router.push({
        path: '/addStore',
        query: {
          type,
          register_type: 'alibaba',
          register_key: this.key
        }
      });
    },

    getToken() {
      this.loading = true
      this.loadingText = "加载中"
      this.$get(this.$api.alibabaAuthToken, {code: this.code}).then(res => {

        this.res = res
        if (res.status == 200) {
          if (res.data.success) {
            localStorage.setItem('logintoken_shop', res.data.token.token)
            localStorage.setItem('userdata_shop', JSON.stringify(res.data.user))
            this.$store.commit('saveShopData', res.data.shop)
            this.getPermissionList();
          } else {
            if (res.data.key) {
              this.key = res.data.key
              //this.key = "alibaba389363008201698468";
              //判断用户是否登录

              this.isCkeck = true;
              this.isUserLogin();
              // console.log("isLogin",this.isLogin,localStorage.getItem('userdata_shop'))
            }
          }

        }
      }).finally(() => {
        this.loading = false
      })
    },
    //判断用户是否登录
    isUserLogin() {
      this.isCkeck = true;
      if (localStorage.getItem('userdata_shop')) {
        this.userData = JSON.parse(localStorage.getItem('userdata_shop'))
        // if (!this.selShopId) {
        //   this.selShopId = this.userData.last_time_shop_id
        // }

        this.isLogin = true
        //弹出店铺 选择页面
        //验证 登录账号是否已经绑定 阿里账号
        this.getShopList()
      } else {
        this.isLogin = false
      }
    },
    getShopList() {
      this.loading = true
      this.loadingText = "店铺列表加载中"
      this.selShopId = null;
      this.$get(this.$api.shopList).then((res) => {
        if (res.status == 200) {
          this.shopList = res.data.list;
        }
      }).finally(() => {
        this.loading = false;
        this.showShopList = true;
      });
    },
    //选择店铺
    tochangeShop(id) {
      this.loading = true
      this.loadingText = "加载中"

      this.$get(this.$api.changeShop + id).then((res) => {
        if (res.status == 200) {
          this.$store.commit('saveShopData', res.data);
          localStorage.setItem('ishavaStore', true);
          this.selShopId = res.data.shop_id;
          //this.isUserLogin()
          //this.getPermissionList()
        }
      }).finally(() => {
        this.loading = false
      });
    },
    getShopInfo() {

    },
    //绑定账号
    bindALibabaAccount() {
      if (this.selShopId) {
        this.loading = true
        this.loadingText = "绑定中"
        let url = this.$api.urlName + '?platform_type=alibaba' + '&auth_param=' + this.key
        this.$get(url).then((res) => {
          if (res.status == 200) {
            this.getPermissionList()
          }
        }).finally(() => {
          this.loading = false
        });
      } else {
        this.$message.error("请选择绑定店铺")
      }

    },

    // 获取权限列表
    getPermissionList() {
      this.$get(this.$api.permissionList).then(res => {
        if (res.status == 200) {
          localStorage.setItem('menuList', JSON.stringify(res.data))
          resetRouter()
          this.routerList = []
          this.handlerRouters(res.data)
          this.routerList.forEach(item => {
            router.addRoute('index', item)
          })
          this.getRuleIds()

        }
      })
    },
    // 获取当前帐号的权限ids
    getRuleIds() {
      this.$get(this.$api.ruleIds).then(res => {
        if (res.status == 200) {
          localStorage.setItem('ruleIds', JSON.stringify(Object.values(res.data)))
          if (this.is_choose_identity != 1) {
            this.$router.push({
              path: "/statistics"
            })
          } else {
            this.loginCheck = true;
          }
        }
      }).finally(() => {
        if (this.loadingInstance) {
          this.loadingInstance.close()
        }
      })
    },
    // 处理路由集合
    handlerRouters(list) {
      list.forEach(item => {
        if (item.component && item.path) {
          this.routerList.push({
            path: item.path,
            name: item.title,
            'component': () => import(`@/views${item.component}`),
            meta: {requireAuth: true}
          })
        }
        if (item.child.length > 0) {
          this.handlerRouters(item.child)
        }
      })
    }, // 复制
    tocopy(info) {
      let target = document.createElement('input'); //创建input节点
      target.value = info; // 给input的value赋值
      document.body.appendChild(target); // 向页面插入input节点
      target.select(); // 选中input
      document.execCommand('Copy');
      document.body.removeChild(target);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        localStorage.setItem('logintoken_shop', '')
        localStorage.setItem('userdata_shop', '')
        localStorage.setItem('ishavaStore', '')
        this.userData = null
        this.isUserLogin()
        this.$message({
          type: 'success',
          message: '已退出登录!'
        })
      })
    },
  }
}
</script>

<style scoped>
body {
  overflow: hidden;
}

.welcome-container {
  width: 100vw;
  height: 100vh;
  position: relative;
}

.welcome {
  //margin-top: 15px;

  box-sizing: border-box;


}


.welcome-head {
  height: 90px;
  position: relative;
}

.welcome-head .head-container {
  width: 1400px;

  margin-left: auto;
  margin-right: auto;
  display: flex;
  line-height: 90px;
}


.welcome-head .head-container .tag {
  color: #9d9d9d;
  font-size: 24px;
}

.welcome-head .head-container .segmentation {
  margin: 0 20px;
  color: #cdcdcd;
  font-size: 24px;
  position: relative;
  top: -3px;
}

.head-container img {
  margin-top: 25px;
  width: 142px;
  height: 41px;
}

.welcome-body {
  width: 100%;
  height: calc(100vh - 90px);
  background-size: cover;
  background-image: url("../../../static/authwelcome_bg.jpg");
}

.body-container {
  width: 1400px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  font-family: "Microsoft YaHei";
}

.body-container .body-left, .body-container .body-right {
  margin-top: 200px;
}

.body-container .body-left {
  width: 600px;
  padding-left: 20px;
}

.body-container .body-right {
  width: 500px;
}

.body-left .tag1 {
  font-size: 72px;

}

.body-left .tag2 {
  font-size: 42px;
  margin-top: 63px;
}

.body-left .tag3 {
  margin-top: 90px;
  display: flex;
  font-size: 20px;
}

.body-left .tag3 ul {
  margin: 0;
}

.body-left .tag3 ul li {
  line-height: 40px;
}

.body-left .tag3-left, .body-left .tag3-right {

}

.body-left .tag3-left {
  width: 200px;
  border-right: 2px solid #c0c4cc;
}

.body-left .tag3-right {
  padding-left: 20px;
  width: 400px;
}

.body-left .tag3-right ul {
  list-style-type: none;
}

.body-left .tag3-right li span {
  font-size: 30px;
  font-weight: bold;
}

.login-bing-shop {
  padding: 20px 25px 15px 25px;
  background: #fff;
  text-align: left;
  width: 350px;
  border-radius: 5px;
  box-shadow: 3px 3px 6px silver;

}

.select-shop {
  display: none;
  width: 350px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}


.shop-list {

  margin-bottom: 20px;
}


.shop-list .title {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  color: #ffaf36;
  margin-bottom: 15px;
}

.shop-list .title2 {

  font-size: 12px;
  line-height: 20px;
  text-align: center;
  margin-bottom: 15px;
}

.shop-list-items {
  display: flex;
  flex-wrap: wrap;

}

.shop-list-item {
  margin-top: 5px;
  box-sizing: border-box;
  width: 20%;
  margin: 5px;
  padding: 10px 5px;
  border-radius: 5px;

  cursor: pointer;
  text-align: center;
}

.shop-list-item .shop-name {
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap; /* 保持文本在一行，不换行 */
  overflow: hidden; /* 隐藏溢出容器的文本 */
  text-overflow: ellipsis; /* 溢出的文本显示为省略号 */
}

.shop-list-item.sel-shop-active {
  background-color: rgba(255, 175, 54, 0.77);
  box-shadow: 0 2px 8px 0 rgba(255, 175, 54, 0.44);
  color: #FFFFFF;
}


.s_once {
  width: 170px;
  padding: 20px 0 30px;
  border-radius: 20px;
  background: white;
  border: 2px solid #f5f5f5;
  box-shadow: 0 2px 8px 0 rgb(0 0 0 / 10%);
  margin-right: 20px;
  margin-bottom: 20px;
  transition: all 0.2s;
}

.s_once:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 8px 0 rgb(30 142 255 / 50%);
  cursor: pointer;
}

.logo {
  display: block;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 0 auto;
}

.s_once p {
  font-size: 14px;
  color: #303133;
  font-weight: 600;
  text-align: center;
}

.but-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.but {
  cursor: pointer;
  padding: 10px 20px;
  font-size: 14px;
  color: #ffaf36;
  border-radius: 4px;
  text-align: center;
  margin-bottom: 10px;
}

.bind-but {
  width: 100%;
  background-color: #ffaf36;
  color: #FFFFFF;
}

.bind-add-store {
  width: 100px;
}

.bind-exit {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/alibabaAuth/index.vue